<template>
	<el-dialog :visible.sync="isShowNavTip" :title="null" :modal='false' width="15.4rem" :show-close="false">
		<div class="nav_tip">
			<div class="nav_tc top_01">
				<div class="nav_tc_d" @click="userInfoClick">
					<i class="el-icon-user nav_tc_i"></i>
					<span class="nav_tc_s">个人信息</span>
				</div>
				<div class="nav_tc_d" @click="clickChangePwd">
					<i class="el-icon-lock nav_tc_i"></i>
					<span class="nav_tc_s">修改密码</span>
				</div>
				<div class="nav_tc_d" @click="clickLoginOut">
					<i class="el-icon-switch-button nav_tc_i"></i>
					<span class="nav_tc_s">退出登录</span>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'navTip',
	props: {},
	data() {
		return {
			isShowNavTip: false,
			userInfo: {}
		}
	},
	components: {},
	mounted() { },
	methods: {
		showTip(userInfo) {
			this.userInfo = userInfo;
			this.isShowNavTip = true;
		},

		// 修改密码
		clickChangePwd() {
			this.$emit('clickChangePwd')
		},

		// 个人信息
		userInfoClick() {
			this.$emit('userInfoClick')
		},

		// 退出登录
		clickLoginOut() {
			this.$confirm('退出登录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				setTimeout(() => {
					// this.disconnectToHub();
					if (this.$tabs) {
						this.$tabs.reset();
					}
					localStorage.clear();
					sessionStorage.removeItem('accessToken');
					this.$router.replace({
						path: '/login',
					});
					this.$message({
						type: 'success',
						message: '已退出登录!',
					});
					this.isShowNavTip = false;
				}, 300);
			})
		},

	}
}
</script>

<style scoped>
.nav_tip {
	width: 216px;
	background: #eeeeee;
	color: #000000;
	padding: 15px 15px;
	box-shadow: 0 0 10px 0 #bcbcbc;
}

.nt_user {
	width: 100%;
	height: 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
}

.nt_v {
	border: 1px solid #55aaff;
	padding: 2px 3px;
	border-radius: 3px;
	color: #55aaff;
	font-size: 8px;
}

.nav_tc {
	width: 216px;
	background: #fff;
	border-radius: 10px;
	margin-top: 10px;
}

.nav_tc_d {
	width: 100%;
	height: 35px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.nav_tc_d:hover {
	background: #f4f4f4;
}

.nav_tc_i {
	font-size: 18px;
	margin-right: 8px;
	margin-left: 10px;
}

.nav_tc_s {
	font-size: 14px;
}

.tbl_user {
	font-size: 12px;
	font-weight: 600;
	color: #ffffff;
	padding: 6px 6px;
	background: #55aaff;
	border-radius: 5px;
	margin-left: 10px;
	cursor: pointer;
}

.com_name {
	font-size: 12px;
	color: #ababab;
	margin-top: 8px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.cn_d {
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.top_01 {
	margin-top: -5px;
}

	::v-deep(.el-dialog) {
	position: absolute;
	margin-top: 0px !important;
	right: 5px;
	top: 60px;
}

::v-deep(.el-dialog__header) {
	display: none;
}

::v-deep(.el-dialog__body) {
	padding: 0px 0px;
	background-color: #fff;
	padding-bottom: 0px !important;
}
</style>